import {useQuery} from 'react-query';
import {getCardDetail} from '.';

const useGetCardNumber = (bank_name?: string) => {
  const {data, isLoading, refetch} = useQuery(
    ['get-cart-detail-list', bank_name],
    () => getCardDetail(bank_name),
    {
      enabled: Boolean(bank_name),
    },
  );

  return {
    data,
    cadNumberIsLoading: isLoading,
    refetch,
  };
};

export default useGetCardNumber;
